/** Song-tempo clicks on the audio clock: a one-bar count-in before the music, and the click track while you sing. */
import { useEffect } from "react";
import { beep } from "@/lib/clickTone";
import { beatLen, nextBeat } from "@/lib/tempoKey";

export const COUNT_IN = 4;

/** One bar of clicks that ends a beat before the music's next beat. → { start: when the music must start, times } */
export function scheduleCountIn(ctx, tempo, from) {
  const p = beatLen(tempo);
  const lead = nextBeat(tempo, from) - from;
  const start = ctx.currentTime + 0.15 + COUNT_IN * p - lead;
  const times = Array.from({ length: COUNT_IN }, (_, i) => start + lead - (COUNT_IN - i) * p);
  times.forEach((t, i) => beep(ctx, t, { freq: i === COUNT_IN - 1 ? 1320 : 880, gain: 0.35 }));
  return { start, times };
}

/** A soft click on every beat while `on` and the engine plays (never before `from`, where the music starts). */
export function useClickTrack(engine, tempo, on, from) {
  useEffect(() => {
    if (!on || !tempo) return undefined;
    const p = beatLen(tempo);
    let next = null;
    const tick = () => {
      if (!engine.playing) { next = null; return; }
      const { ctx } = engine;
      const song = Math.max(ctx.currentTime - engine.startTime, from);
      if (next == null) next = Math.ceil((song - tempo.offset) / p - 1e-6);
      for (let s = tempo.offset + next * p; s < song + 0.2; s = tempo.offset + next * p) {
        const at = engine.startTime + s;
        if (at >= ctx.currentTime - 0.005) beep(ctx, Math.max(at, ctx.currentTime), { freq: 1700, dur: 0.035, gain: 0.2 });
        next += 1;
      }
    };
    tick();
    const id = setInterval(tick, 50);
    return () => clearInterval(id);
  }, [engine, tempo, on, from]);
}
